<template>
  <div class="pro-products m-b-100">
    <div class="pro-products-button">
      <div class="pro-products-text">
        <p class="code">{{ detail.detail.name }}</p>
        <p class="code">
          <Tooltip content="点击询价单编号复制" theme="light" placement="top">
            <span
              ref="codeCon"
              :data-clipboard-text="detail.detail.code"
              class="btn_code enquiryCode"
              @click="copyCode"
            >
              询价单编号：
              <span ref="codeFefs">{{ detail.detail.code }}</span>
            </span>
          </Tooltip>

          <Tooltip
            content="Bottom Center text"
            placement="bottom"
            theme="light"
            max-width="340"
          >
            <i class="iconfont icon-exclamationpoint"></i>
            <div slot="content" class="tool-content">
              <p>询价单注意事项</p>
              <ul>
                <li>询价单”是住逻辑发送给客户报价的载体,询价时间为T+1天。</li>
                <li>变更项目所在地后，新的询价单将重新计算供应链服务费。</li>
                <li>
                  由于定制类存在个体差异的特殊要求,产品以最终签订合同时的设计图纸为准。
                </li>
                <li>原材料的采购随市场行情波动,所以询价单有效期为3个月。</li>
                <li>如有疑问请联系客服:400-998-0137(服务时间 09:00-18:00)。</li>
              </ul>
            </div>
          </Tooltip>
        </p>
        <p class="time">{{ detail.detail.createTime | date }}</p>
        <p class="address">
          项目所在地：{{
            getAddress(detail.detail.locationId, "second")
          }}（变更地址将重新计算供应链服务费）
        </p>
      </div>
      <div class="right">
        <a
          href="https://b.zhulogic.com/collect/collectImages/chat.html"
          target="_blank"
        >
          <Button size="large" style="margin-right: 20px">在线联系</Button>
        </a>
        <Button
          v-if="detail.detail.cancel"
          size="large"
          style="margin-right: 20px"
          @click="undoHandle"
          >撤销报价</Button
        >
        <Button
          v-if="permissionFuc('inquiry:export')"
          type="primary"
          size="large"
          style="margin-right: 15px"
          @click="exportExcel"
          :disabled="exportLoading"
        >
          <i class="iconfont icon-export"></i>
          {{ exportLoading ? "导出中..." : "导出Excel" }}
        </Button>
        <Tooltip
          v-if="permissionFuc('inquiry:share')"
          content="Bottom Center text"
          placement="bottom-end"
          theme="light"
          max-width="340"
        >
          <Button type="primary" size="large">
            <i class="iconfont icon-sharen"></i>分享
          </Button>
          <div slot="content" class="tool-content">
            <p class="shareTitle">分享询价单</p>
            <div class="shareDialog">
              <p class="text"><Badge status="error" />只能阅读</p>
              <Row
                :gutter="10"
                type="flex"
                placeholder="分享链接"
                justify="center"
                align="middle"
              >
                <Col span="20">
                  <input
                    class="hidden-input"
                    type="”hidden“"
                    id="success_form_input"
                    :value="shareUrl"
                  />
                </Col>
                <Col span="4">
                  <Button
                    class="btn"
                    style="margin-top: 12px"
                    data-clipboard-target="#success_form_input"
                    type="primary"
                    >复制</Button
                  >
                </Col>
              </Row>
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
    <product-item :detail="detail"></product-item>
    <div
      class="bottom-price"
      :class="
        detail.detail.valid === 2 || isDisabled(detail.lists) ? 'disabled' : ''
      "
      v-if="
        detail.detail &&
        detail.detail.status === 2 &&
        detail.detail.quotedNum > 0
      "
    >
      <Row
        type="flex"
        justify="end"
        class="enquiry-row"
        v-if="detail.detail.productPrice"
      >
        <Col span="3">
          <Checkbox
            v-if="detail.detail.showFabricButton"
            @on-change="changeFabricAll"
            v-model="detail.detail.inquiryHasFabric"
            >含面料</Checkbox
          >
        </Col>
        <Col offset="15" span="3" class="name"
          >产品总价(*{{ detail.detail.num }})</Col
        >
        <Col offset="1" span="2">
          <span v-if="detail.detail.valid === 2 || isDisabled(detail.lists)"
            >报价失效</span
          >
          <span v-else>{{
            detail.detail.productPrice | currency("¥", "2")
          }}</span>
        </Col>
      </Row>
      <Row
        v-if="detail.detail.serviceCost"
        type="flex"
        justify="end"
        class="enquiry-row"
      >
        <Col offset="18" span="3" class="name">供应链服务费</Col>
        <Col offset="1" span="2">
          <span v-if="detail.detail.valid === 2 || isDisabled(detail.lists)"
            >报价失效</span
          >
          <span v-else>{{
            detail.detail.serviceCost | currency("¥", "2")
          }}</span>
        </Col>
      </Row>
      <Row
        type="flex"
        justify="end"
        style="margin-top: -17px"
        class="enquiry-row m-r-20"
        v-if="
          detail.detail.serviceCostRecord &&
          detail.detail.serviceCostRecord.display
        "
      >
        <Col
          style="font-size: 14px; color: #777"
          offset="8"
          span="14"
          class="name"
          >{{ detail.detail.serviceCostRecord.display }}</Col
        >
      </Row>
      <Row
        type="flex"
        justify="end"
        style="margin-top: -17px"
        class="enquiry-row m-r-20"
        v-if="
          detail.detail.serviceCost === 0 &&
          !(
            detail.detail.serviceCostRecord &&
            detail.detail.serviceCostRecord.display
          )
        "
      >
        <Col
          style="font-size: 14px; color: #777"
          offset="8"
          span="14"
          class="name"
          >暂不提供供应链服务</Col
        >
      </Row>
      <Row
        type="flex"
        justify="end"
        class="enquiry-row"
        v-if="detail.detail.taxCost"
        ß
      >
        <Col offset="18" span="3" class="name">税金</Col>
        <Col offset="1" span="2">
          <span v-if="detail.detail.valid === 2 || isDisabled(detail.lists)"
            >报价失效</span
          >
          <span v-else>{{ detail.detail.taxCost | currency("¥", "2") }}</span>
        </Col>
      </Row>
      <Row
        type="flex"
        justify="end"
        align="middle"
        class="total"
        v-if="detail.detail.totalPrice"
      >
        <Col offset="18" span="3" class="name">询价单总金额</Col>
        <Col offset="1" span="2" class="price">
          <span v-if="detail.detail.valid === 2 || isDisabled(detail.lists)"
            >报价失效</span
          >
          <span v-else>
            {{ detail.detail.totalPrice | currency("¥", "2") }}
          </span>
        </Col>
      </Row>
    </div>
    <div
      class="bottom-btn"
      v-if="
        detail.detail &&
        detail.detail.status === 2 &&
        detail.detail.quotedNum > 0
      "
    >
      <Button
        v-if="permissionFuc('inquiry:order')"
        class="primary-red"
        type="primary"
        :disabled="isDisabled(detail.lists)"
        size="large"
        long
        @click="submit"
        >提交订单</Button
      >
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Clipboard from "clipboard";
import { getAddress, downloadURI } from "@/utils";
import { OLD_BASIC_URL } from "@/constants";
import { setTimeout } from "timers";
import { permissionFuc } from "@/utils/permissions.js";
import ProductItem from "@/components/product-item.vue";
export default {
  data() {
    return {
      permissionFuc: permissionFuc,
      getAddress: getAddress,
      OLD_BASIC_URL: OLD_BASIC_URL,
      shareUrl: "",
      exportLoading: false,
      detail: {
        detail: "",
        lists: [],
      },
      lists: [],
    };
  },
  components: { ProductItem },
  beforeRouteEnter(to, from, next) {
    axios
      .post(
        `/designer_api/inquiry/item/v1`,
        { id: to.params.enquiryId },
        { globalLoading: true }
      )
      .then((res) => {
        next((vm) => {
          vm.detail.lists = res;
          vm.isDisabled(vm.detail.lists, true);
        });
      });
  },
  computed: {
    projectDetail() {
      return this.$store.state.projectDetail;
    },
  },
  methods: {
    // 判断又没失效产品
    isDisabled(lists, msg = false) {
      if (!lists || lists.length === 0) return false;
      let newLists = [];
      lists.forEach((_lists) => {
        _lists.itemAreaList &&
          _lists.itemAreaList.forEach((_item) => {
            newLists.push(_item);
          });
      });
      if (newLists.filter((item) => item.product.disabled === 1).length > 0) {
        if (msg) {
          this.$Message.info({
            content: "存在产品失效，请重新询价！",
            duration: 10,
          });
        }
        return true;
      } else {
        return false;
      }
    },

    /* 是否要包含面料 */
    changeFabricAll(val) {
      let params = {
        hasFabric: val,
        id: this.$route.params.enquiryId,
      };
      axios.put(`/designer_api/inquiry/has_fabric`, params).then((res) => {
        this.getLists();
        this.getDetail();
      });
    },

    getLists() {
      axios
        .post(
          `/designer_api/inquiry/item/v1`,
          { id: this.$route.params.enquiryId },
          { globalLoading: true }
        )
        .then((res) => {
          res.forEach((_lists) => {
            _lists.itemAreaList &&
              _lists.itemAreaList.forEach((item) => {
                Object.assign(item.product, {
                  num: item.num,
                  productId: item.id,
                });
              });
          });

          this.detail.lists = res;
          this.isDisabled(this.detail.lists, true);
        });
    },
    // 导出excel
    exportExcel() {
      this.exportLoading = true;
      axios
        .get(
          `/designer_api/inquiry/${this.$route.params.enquiryId}/excel_export`
        )
        .then((res) => {
          downloadURI(this.ossPrefix + res);
          this.exportLoading = false;
        });
    },
    // 获取分享连接
    getShareList() {
      axios
        .get(`/designer_api/inquiry/${this.$route.params.enquiryId}/share_url`)
        .then((res) => {
          this.shareUrl = res;
          this.copyShareUrl();
        });
    },
    /* 复制询价单编号 */
    copyCode() {
      let clipboard = new Clipboard(".btn_code");
      setTimeout(() => {
        this.$Message.success("成功复制到剪切板");
      }, 500);
    },
    // 复制连接
    copyShareUrl() {
      let clipboard = new Clipboard(".btn");
      clipboard.on("success", (e) => {
        this.$Message.success("成功复制到剪切板");
        e.clearSelection();
      });
      clipboard.on("error", (e) => {
        this.$Message.error("复制失败，请手动复制");
      });
    },

    getDetail() {
      axios
        .get(`/designer_api/inquiry/${this.$route.params.enquiryId}`)
        .then((res) => {
          this.detail.detail = res;
        });
    },

    /* 判断用户是否为认证设计师，并且进行过实名认证 */
    person_auth() {
      if (
        this.$store.state.userInfo.companyAuthStatus <= 1 &&
        this.$store.state.userInfo.realAuthStatus <= 1
      ) {
        this.$Modal.confirm({
          title: "提示",
          okText: "去实名认证",
          cancelText: "返回项目",
          content: "<p>亲，非常抱歉，您还没有进行实名认证，暂时不能下单？</p>",
          onOk: () => {
            window.location.href = `${OLD_BASIC_URL}/my/personal/accountSetting`;
          },
        });
        return false;
      }
      return true;
    },
    /* 提交订单 */
    submit() {
      if (!this.person_auth()) {
        return false;
      }
      this.$router.push({
        name: "CommitOrders",
        query: {
          projectId: this.$route.params.id,
          enquiryId: this.$route.params.enquiryId,
          locationId: this.detail.detail.locationId,
          projectAdditionalDesc: this.detail.detail.projectAdditionalDesc,
          type: this.projectDetail.type || 1,
        },
      });
    },

    /* 撤销 */
    undoHandle() {
      this.$Modal.confirm({
        loading: true,
        width: 450,
        content: `<div class="projectSwitch"> <p><i class="iconfont icon-jinggao1 dialog-content-error"></i></p> <p>是否撤销本次询价？</p></div>`,
        onOk: () => {
          axios
            .put(`/designer_api/projects/${this.$route.params.id}/cancel`)
            .then((res) => {
              this.$Message.success("撤销成功");
              this.getLists();
              this.getDetail();
              this.$Modal.remove();
            })
            .catch((err) => {
              this.$Modal.remove();
            });
        },
      });
    },

    openOnline() {
      this.$nextTick(() => {
        this.$emit("global:sendUdesk");
      });
    },

    udeskHandle(product = null) {
      this.$nextTick(() => {
        (function (a, h, c, b, f, g) {
          a["UdeskApiObject"] = f;
          a[f] =
            a[f] ||
            function () {
              (a[f].d = a[f].d || []).push(arguments);
            };
          g = h.createElement(c);
          g.async = 1;
          g.charset = "utf-8";
          g.src = b;
          c = h.getElementsByTagName(c)[0];
          c.parentNode.insertBefore(g, c);
        })(
          window,
          document,
          "script",
          "https://assets-cli.udesk.cn/im_client/js/udeskApi.js",
          "ud"
        );
        ud({
          code: "260bd3ji",
          link: "https://zhulogic.udesk.cn/im_client/?web_plugin_id=42958",
          mode: "inner",
          color: "#308697",
          targetSelector: "#zaixiankefu",
          selector: ".concolect",
          noBubble: false,
        });

        if (product) {
          ud("showPanel");
        }
      });
    },
  },
  created() {
    this.getDetail();
    this.getShareList();
  },
  mounted() {
    // this.udeskHandle()
  },
  beforeDestroy() {
    this.$Message.destroy();
  },
};
</script>

<style lang="scss">
.pro-products {
  .code {
    font-size: 22px;
    font-weight: 600;
    color: rgba(53, 53, 53, 1);
  }
  .time {
    font-size: 18px;
    font-weight: 400;
    color: rgba(33, 32, 31, 1);
    margin-top: 10px;
  }
  .address {
    font-size: 18px;
    font-weight: 400;
    color: rgba(159, 159, 159, 1);
  }
  .bottom-btn {
    margin: 20px auto;
    width: 200px;
    text-align: center;
  }
  .enquiry-row {
    margin-bottom: 20px;
  }
  .enquiruing {
    color: rgb(225, 75, 93);
  }
  .disabled {
    opacity: 0.6;
  }
  .icon-exclamationpoint {
    color: #ccc;
    cursor: pointer;
    font-size: 22px;
    vertical-align: top;
    margin-left: 10px;
  }
  .tool-content {
    padding: 20px;
    width: 500px;
    color: rgba(62, 62, 62, 1);
    p {
      font-size: 16px;
      width: 275px;
      text-align: center;
      font-weight: bold;
    }
    li {
      width: 280px;
      font-size: 14px;
      margin-top: 10px;
      color: rgba(62, 62, 62, 1);
    }
    .shareDialog {
      width: 250px;
      .text {
        margin-top: 20px;
        margin-bottom: -5px;
        font-size: 14px;
        text-align: left;
      }
    }
    .shareTitle {
      padding-top: -20px;
      padding-bottom: 10px;
      border-bottom: 1px solid #ebeff0;
    }
  }
  .bottom-price {
    margin-top: 30px;
    padding: 30px;
    background: #ffeded;
    font-size: 15px;
    font-weight: 400;
    color: rgba(33, 32, 31, 1);
    padding-bottom: 0px;
    .name {
      text-align: right;
    }
    .total {
      margin-top: 20px;
      height: 60px;
      border-top: 1px solid #dcd8d8;
      .name,
      .price {
        font-size: 18px;
        font-weight: 600;
        color: rgba(33, 32, 31, 1);
      }
      .price {
        color: rgba(208, 2, 27, 1);
      }
    }
  }
  .added-detail {
    background: rgba(252, 250, 247, 1);
    padding: 20px;
    padding-bottom: 20px;
    .insert {
      background: rgba(252, 250, 247, 1);
    }
    .title {
      font-size: 14px;
      font-weight: 500;
      color: #21201f;
    }
    .main {
      font-size: 14px;
      color: rgba(154, 154, 154, 1);
      margin-top: 5px;
    }
  }
  .enquiryCode {
    cursor: pointer;
  }
  .hidden-input {
    width: 200px;
    height: 40px;
    padding: 0 10px;
    background: #ececec;
    border: 1px solid #ddd;
    vertical-align: top;
    display: inline-block;
    margin-top: 15px;
  }
}
</style>
